import { fetchApi } from "../fetchApi";

export async function getVariants({ context, company_id, id }) {
  const domain = [["product_tmpl_id", "=", id]];
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      model: "product.product",
      domain,
      sort: "",
      limit: 300,
      fields: [
        "default_code",
        "barcode",
        "name",
        "website_id",
        "is_published",
        "product_template_attribute_value_ids",
        "company_id",
        "lst_price",
        "standard_price",
        "price_extra",
        "categ_id",
        "type",
        "price",
        "weight",
        "ProHeight",
        "ProWidth",
        "ProLength",
        "image_1920",
        "volume",
        "qty_available",
        "virtual_available",
        "uom_id",
        "product_tmpl_id",
        "active",
      ],
      kwargs: {
        context: {
          active_id: id,
          active_ids: [id],
          active_model: "product.template",
          allowed_company_ids: [company_id],
          bin_size: true,
          create: false,
          default_product_tmpl_id: id,
          lang: context.lang,
          search_default_product_tmpl_id: [148],
          tz: context.tz,
          uid: context.uid,
        },
      },
    },
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };
  return fetchApi({ requestOptions, endpoint: "/web/dataset/search_read" });
}
